const isObject = (value: unknown): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object';
};

const hasTargetWithValue = (
  obj: Record<string, unknown>
): obj is Record<string, unknown> & {
  target: Record<string, unknown> & { value: unknown };
} => {
  return 'target' in obj && isObject(obj.target) && 'value' in obj.target;
};

export const extractValue = (event: unknown): unknown => {
  if (isObject(event)) {
    if (hasTargetWithValue(event)) {
      return event.target.value;
    }

    if ('value' in event) {
      return event.value;
    }
  }

  return event;
};

/**
 * Creates a persisted copy of an event to prevent React's event pooling issues.
 * For non-event values, returns the value as-is.
 */
export const persistEvent = (event: unknown): unknown => {
  if (isObject(event) && hasTargetWithValue(event)) {
    const target = event.target as Record<string, unknown>;
    const currentTarget = event.currentTarget as
      Record<string, unknown> | undefined;

    const persistedTarget = {
      ...target,
      value: target.value
    };

    const persistedCurrentTarget =
      currentTarget && isObject(currentTarget)
        ? {
            ...currentTarget,
            value: currentTarget.value
          }
        : undefined;

    return {
      ...event,
      target: persistedTarget,
      currentTarget: persistedCurrentTarget
    };
  }

  return event;
};
